import React, { useState } from "react";
import { Button, Modal } from "antd";
import { ContactUs } from "../../../../../assets/icons";

function PlanDetail({ planData, enterprice }) {
   const [open, setOpen] = useState(false);
   const getIfIsYearly = localStorage.getItem("isYearly");
   return (
      <>
         <div className="plan-details-modal">
            <a onClick={() => setOpen(true)}>
               <span
                  style={{
                     color: "#F58F45",
                     fontFamily: "Poppins",
                     fontSize: "14px",
                     fontWeight: "500"
                  }}
               >
                  See full plan details
               </span>
            </a>
            <Modal open={open} onOk={() => setOpen(false)} onCancel={() => setOpen(false)} width={900}>
               {
                  enterprice ?
                  <>
                     <div className="enterprice-modal">
                        <h2>Contact us for a Custom Plan</h2>
                        <img src={ContactUs} />
                        <p>Our Enterprise plan is designed to meet your specific needs. Contact us to discuss your requirements and receive a customized offer.</p>
                        <p>Reach out at <a href="mailto:info@kaptechgroup.com" target="_blank">info@kaptechgroup.com</a></p>
                        <div className="closeModal">
                           <Button color="primary" variant="outlined" size="large" onClick={() => setOpen(false)}>Close</Button>
                        </div>
                     </div>
                  </> :
                  <>
                     <h2>{planData?.name}</h2>
                     <p>This plan includes:</p>
                     <ul>
                        <li>
                           With {planData?.workspaceLimit != 0 ? planData?.workspaceLimit : "Unlimited"}{" "}
                           workspaces and{" "}
                           {planData?.membersLimit != 0 ? planData?.membersLimit : "Unlimited"} users per
                           workspace, enjoy{" "}
                           {planData?.databaseLimit != 0 ? (
                              <>a data storage limit of {planData?.databaseLimit}GB</>
                           ) : (
                              <>an unlimited storage</>
                           )}
                        </li>
                     </ul>
                     <p>{planData?.description}</p>
                     <div className="plan-price">
                        <p>Plan's Price</p>
                        <h4>
                           <span>USD </span>$
                           {getIfIsYearly === "true"
                              ? planData.annuallyPrice + "/yr."
                              : planData.monthlyPrice + "/mo."}
                        </h4>
                     </div>
                  </>
               }
            </Modal>
         </div>
         {
            enterprice &&
            <Button
               onClick={() => setOpen(true)}
               type="default"
               className={`defaultButton`}
            >
               Choose this plan
            </Button>
         }
      </>
   );
}

export { PlanDetail };
